module.exports = __webpack_public_path__ + "static/media/Oxygen-Bold.25394de7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/OxygenBold/Oxygen-Bold.eot
// module id = 2943
// module chunks = 0